angular.module('impactx.budget').directive('ixBudgetReadonly', function () {
    return {
        scope: {
            budget: '='
        },
        restrict: 'E',
        templateUrl: 'modules/budget/templates/budgetreadonly.tmpl.html'
    };
});